import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

import { faShopify } from '@fortawesome/free-brands-svg-icons';

// Duotone
import { faCartShopping as fadCartShopping } from '@fortawesome/pro-duotone-svg-icons/faCartShopping';
import { faChartNetwork as fadChartNetwork } from '@fortawesome/pro-duotone-svg-icons/faChartNetwork';
import { faCogs as fadCogs } from '@fortawesome/pro-duotone-svg-icons/faCogs';
import { faCreditCard as fadCreditCard } from '@fortawesome/pro-duotone-svg-icons/faCreditCard';
import { faExclamationTriangle as fadExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons/faExclamationTriangle';
import { faGlobeEurope as fadGlobeEurope } from '@fortawesome/pro-duotone-svg-icons/faGlobeEurope';
import { faHandHoldingBox as fadHandHoldingBox } from '@fortawesome/pro-duotone-svg-icons/faHandHoldingBox';
import { faHandHoldingUsd as fadHandHoldingUsd } from '@fortawesome/pro-duotone-svg-icons/faHandHoldingUsd';
import { faHome as fadHome } from '@fortawesome/pro-duotone-svg-icons/faHome';
import { faInfoCircle as fadInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle';
import { faListCheck as fadListCheck } from '@fortawesome/pro-duotone-svg-icons/faListCheck';
import { faPiggyBank as fadPiggyBank } from '@fortawesome/pro-duotone-svg-icons/faPiggyBank';
import { faQuestion as fadQuestion } from '@fortawesome/pro-duotone-svg-icons/faQuestion';
import { faShoppingCart as fadShoppingCart } from '@fortawesome/pro-duotone-svg-icons/faShoppingCart';
import { faStore as fadStore } from '@fortawesome/pro-duotone-svg-icons/faStore';
import { faUniversity as fadUniversity } from '@fortawesome/pro-duotone-svg-icons/faUniversity';
import { faUser as fadUser } from '@fortawesome/pro-duotone-svg-icons/faUser';
// Light
import { faAngleDown as falAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleLeft as falAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import { faAngleRight as falAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faArrowDown as falArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown';
import { faArrowRight as falArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { faArrowRightFromBracket as falArrowRightFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowRightFromBracket';
import { faArrowsRotate as falArrowsRotate } from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import { faArrowsSplitUpAndLeft as falArrowsSplitUpAndLeft } from '@fortawesome/pro-light-svg-icons/faArrowsSplitUpAndLeft';
import { faArrowTurnDownLeft as falArrowTurnDownLeft } from '@fortawesome/pro-light-svg-icons/faArrowTurnDownLeft';
import { faBarcode as falBarcode } from '@fortawesome/pro-light-svg-icons/faBarcode';
import { faBars as falBars } from '@fortawesome/pro-light-svg-icons/faBars';
import { faBasketShopping as falBasketShopping } from '@fortawesome/pro-light-svg-icons/faBasketShopping';
import { faBell as falBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faBolt as falBolt } from '@fortawesome/pro-light-svg-icons/faBolt';
import { faBuilding as falBuilding } from '@fortawesome/pro-light-svg-icons/faBuilding';
import { faBuildingColumns as falBuildingColumns } from '@fortawesome/pro-light-svg-icons/faBuildingColumns';
import { faCalculator as falCalculator } from '@fortawesome/pro-light-svg-icons/faCalculator';
import { faCalculatorSimple as falCalculatorSimple } from '@fortawesome/pro-light-svg-icons/faCalculatorSimple';
import { faCalendar as falCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faCalendarCheck as falCalendarCheck } from '@fortawesome/pro-light-svg-icons/faCalendarCheck';
import { faCalendarDay as falCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import { faCalendarEdit as falCalenderEdit } from '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import { faChartMixed as falChartMixed } from '@fortawesome/pro-light-svg-icons/faChartMixed';
import { faCheck as falCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronLeft as falChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faChevronUp as falChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faCircleCheck as falCircleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import { faCircleExclamation as falCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { faCircleNotch as falCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch';
import { faCircleQuestion as falCircleQuestion } from '@fortawesome/pro-light-svg-icons/faCircleQuestion';
import { faClipboardCheck as falClipboardCheck } from '@fortawesome/pro-light-svg-icons/faClipboardCheck';
import { faClock as falClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faClockRotateLeft as falClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faCog as falCog } from '@fortawesome/pro-light-svg-icons/faCog';
import { faCopy as falCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faCreditCard as falCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { faCreditCardBlank as falCreditCardBlank } from '@fortawesome/pro-light-svg-icons/faCreditCardBlank';
import { faDeleteLeft as falDeleteLeft } from '@fortawesome/pro-light-svg-icons/faDeleteLeft';
import { faDesktop as falDesktop } from '@fortawesome/pro-light-svg-icons/faDesktop';
import { faDownload as falDownload } from '@fortawesome/pro-light-svg-icons/faDownload';
import { faEdit as falEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faEllipsis as falEllipsis } from '@fortawesome/pro-light-svg-icons/faEllipsis';
import { faEllipsisV as falEllipsisV } from '@fortawesome/pro-light-svg-icons/faEllipsisV';
import { faEllipsisVertical as falEllipsisVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisVertical';
import { faEnvelope as falEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faEnvelopeOpen as falEnvelopeOpen } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpen';
import { faEnvelopeOpenText as falEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import { faEraser as falEraser } from '@fortawesome/pro-light-svg-icons/faEraser';
import { faExclamationCircle as falExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { faExternalLink as falExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink';
import { faExternalLinkSquare as falExternalLinkSquare } from '@fortawesome/pro-light-svg-icons/faExternalLinkSquare';
import { faEye as falEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faEyeSlash as falEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import { faFileChartColumn as falFileChartColumn } from '@fortawesome/pro-light-svg-icons/faFileChartColumn';
import { faFileExport as falFileExport } from '@fortawesome/pro-light-svg-icons/faFileExport';
import { faFileInvoice as falFileInvoice } from '@fortawesome/pro-light-svg-icons/faFileInvoice';
import { faFileMagnifyingGlass as falFileMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faFileMagnifyingGlass';
import { faFilePdf as falFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf';
import { faFilePen as falFilePen } from '@fortawesome/pro-light-svg-icons/faFilePen';
import { faFilter as falFilter } from '@fortawesome/pro-light-svg-icons/faFilter';
import { faGear as falGear } from '@fortawesome/pro-light-svg-icons/faGear';
import { faGearComplex as falGearComplex } from '@fortawesome/pro-light-svg-icons/faGearComplex';
import { faGiftCard as falGiftCard } from '@fortawesome/pro-light-svg-icons/faGiftCard';
import { faGrid2 as falGrid2 } from '@fortawesome/pro-light-svg-icons/faGrid2';
import { faHistory as falHistory } from '@fortawesome/pro-light-svg-icons/faHistory';
import { faHourglassHalf as falHourglassHalf } from '@fortawesome/pro-light-svg-icons/faHourglassHalf';
import { faHouse as falHouse } from '@fortawesome/pro-light-svg-icons/faHouse';
import { faInfoCircle as falInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faKey as falKey } from '@fortawesome/pro-light-svg-icons/faKey';
import { faLanguage as falLanguage } from '@fortawesome/pro-light-svg-icons/faLanguage';
import { faLifeRing as falLifeRing } from '@fortawesome/pro-light-svg-icons/faLifeRing';
import { faLightbulbOn as falLightbulbOn } from '@fortawesome/pro-light-svg-icons/faLightbulbOn';
import { faList as falList } from '@fortawesome/pro-light-svg-icons/faList';
import { faListCheck as falListCheck } from '@fortawesome/pro-light-svg-icons/faListCheck';
import { faListTree as falListTree } from '@fortawesome/pro-light-svg-icons/faListTree';
import { faLock as falLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faLockOpen as falLockOpen } from '@fortawesome/pro-light-svg-icons/faLockOpen';
import { faMagnifyingGlass as falMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faMegaphone as falMegaphone } from '@fortawesome/pro-light-svg-icons/faMegaphone';
import { faMemoCircleInfo as falMemoCircleInfo } from '@fortawesome/pro-light-svg-icons/faMemoCircleInfo';
import { faMinus as falMinus } from '@fortawesome/pro-light-svg-icons/faMinus';
import { faMobileAlt as falMobileAlt } from '@fortawesome/pro-light-svg-icons/faMobileAlt';
import { faMoneyBillTransfer as falMoneyBillTransfer } from '@fortawesome/pro-light-svg-icons/faMoneyBillTransfer';
import { faMoneyBillWave as falMoneyBillWave } from '@fortawesome/pro-light-svg-icons/faMoneyBillWave';
import { faMoneyCheckPen as falMoneyCheckPen } from '@fortawesome/pro-light-svg-icons/faMoneyCheckPen';
import { faMoon as falMoon } from '@fortawesome/pro-light-svg-icons/faMoon';
import { faPaperclip as falPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip';
import { faPaperclipVertical as falPaperclipVertical } from '@fortawesome/pro-light-svg-icons/faPaperclipVertical';
import { faPaperPlane as falPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faPiggyBank as falPiggyBank } from '@fortawesome/pro-light-svg-icons/faPiggyBank';
import { faPlay as falPlay } from '@fortawesome/pro-light-svg-icons/faPlay';
import { faPlayCircle as falPlayCircle } from '@fortawesome/pro-light-svg-icons/faPlayCircle';
import { faPlug as falPlug } from '@fortawesome/pro-light-svg-icons/faPlug';
import { faPlus as falPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faPlusCircle as falPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import { faPrint as falPrint } from '@fortawesome/pro-light-svg-icons/faPrint';
import { faQuestionCircle as falQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import { faReceipt as falReceipt } from '@fortawesome/pro-light-svg-icons/faReceipt';
import { faRobot as falRobot } from '@fortawesome/pro-light-svg-icons/faRobot';
import { faScaleBalanced as falScaleBalanced } from '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import { faScaleUnbalanced as falScaleUnbalanced } from '@fortawesome/pro-light-svg-icons/faScaleUnbalanced';
import { faScrewdriverWrench as falScrewdriverWrench } from '@fortawesome/pro-light-svg-icons/faScrewdriverWrench';
import { faSearchPlus as falSearchPlus } from '@fortawesome/pro-light-svg-icons/faSearchPlus';
import { faShoppingBasket as falShoppingBasket } from '@fortawesome/pro-light-svg-icons/faShoppingBasket';
import { faShoppingCart as falShoppingCart } from '@fortawesome/pro-light-svg-icons/faShoppingCart';
import { faSigma as falSigma } from '@fortawesome/pro-light-svg-icons/faSigma';
import { faSpinnerThird as falSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird';
import { faStopwatch as falStopwatch } from '@fortawesome/pro-light-svg-icons/faStopwatch';
import { faStore as falStore } from '@fortawesome/pro-light-svg-icons/faStore';
import { faSun as falSun } from '@fortawesome/pro-light-svg-icons/faSun';
import { faSyncAlt as falSyncAlt } from '@fortawesome/pro-light-svg-icons/faSyncAlt';
import { faTableColumns as falTableColumns } from '@fortawesome/pro-light-svg-icons/faTableColumns';
import { faTimelineArrow as falTimelineArrow } from '@fortawesome/pro-light-svg-icons/faTimelineArrow';
import { faTimes as falTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faTrash as falTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faTrashCan as falTrashCan } from '@fortawesome/pro-light-svg-icons/faTrashCan';
import { faTruckFast as falTruckFast } from '@fortawesome/pro-light-svg-icons/faTruckFast';
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faUserCircle as falUserCircle } from '@fortawesome/pro-light-svg-icons/faUserCircle';
import { faUsers as falUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faWallet as falWallet } from '@fortawesome/pro-light-svg-icons/faWallet';
import { faWandMagicSparkles as falWandMagicSparkles } from '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import { faXmark as falXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faEllipsisVertical as farEllipsisVertical } from '@fortawesome/pro-regular-svg-icons/faEllipsisVertical';
// Regular
import { faAngleDown as farAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';
import { faBallotCheck as farBallotCheck } from '@fortawesome/pro-regular-svg-icons/faBallotCheck';
import { faBan as farBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faBolt as farBolt } from '@fortawesome/pro-regular-svg-icons/faBolt';
import { faBoltSlash as farBoltSlash } from '@fortawesome/pro-regular-svg-icons/faBoltSlash';
import { faBox as farBox } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faBuilding as farBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import { faCalendarCheck as farCalendarCheck } from '@fortawesome/pro-regular-svg-icons/faCalendarCheck';
import { faCalendarClock as farCalendarClock } from '@fortawesome/pro-regular-svg-icons/faCalendarClock';
import { faCartShopping as farCartShopping } from '@fortawesome/pro-regular-svg-icons/faCartShopping';
import { faCheck as farCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronLeft as farChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight as farChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronUp as farChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faCircleNotch as farCircleNotch } from '@fortawesome/pro-regular-svg-icons/faCircleNotch';
import { faCloudDownload as farCloudDownload } from '@fortawesome/pro-regular-svg-icons/faCloudDownload';
import { faCodeFork as farCodeFork } from '@fortawesome/pro-regular-svg-icons/faCodeFork';
import { faCog as farCog } from '@fortawesome/pro-regular-svg-icons/faCog';
import { faEllipsis as farEllipsis } from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { faExclamationCircle as farExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import { faFileInvoice as farFileInvoice } from '@fortawesome/pro-regular-svg-icons/faFileInvoice';
import { faFileInvoiceDollar as farFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons/faFileInvoiceDollar';
import { faFilePen as farFilePen } from '@fortawesome/pro-regular-svg-icons/faFilePen';
import { faFilter as farFilter } from '@fortawesome/pro-regular-svg-icons/faFilter';
import { faFlag as farFlag } from '@fortawesome/pro-regular-svg-icons/faFlag';
import { faGlobe as farGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe';
import { faGripDots as farGripDots } from '@fortawesome/pro-regular-svg-icons/faGripDots';
import { faHandHoldingCircleDollar as farHandHoldingCircleDollar } from '@fortawesome/pro-regular-svg-icons/faHandHoldingCircleDollar';
import { faHome as farHome } from '@fortawesome/pro-regular-svg-icons/faHome';
import { faInfoCircle as farInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faLifeRing as farLifeRing } from '@fortawesome/pro-regular-svg-icons/faLifeRing';
import { faMoneyBillTransfer as farMoneyBillTransfer } from '@fortawesome/pro-regular-svg-icons/faMoneyBillTransfer';
import { faOctagonExclamation as farOctagonExclamation } from '@fortawesome/pro-regular-svg-icons/faOctagonExclamation';
import { faPaperclip as farPaperclip } from '@fortawesome/pro-regular-svg-icons/faPaperclip';
import { faPaperPlane as farPaperPlane } from '@fortawesome/pro-regular-svg-icons/faPaperPlane';
import { faPaperPlaneTop as farPaperPlaneTop } from '@fortawesome/pro-regular-svg-icons/faPaperPlaneTop';
import { faPen as farPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faPenToSquare as farPenToSquare } from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import { faPersonSimple as farPersonSimple } from '@fortawesome/pro-regular-svg-icons/faPersonSimple';
import { faPlusCircle as farPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle';
import { faShoppingBasket as farShoppingBasket } from '@fortawesome/pro-regular-svg-icons/faShoppingBasket';
import { faSignOut as farSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut';
import { faStore as farStore } from '@fortawesome/pro-regular-svg-icons/faStore';
import { faTag as farTag } from '@fortawesome/pro-regular-svg-icons/faTag';
import { faTags as farTags } from '@fortawesome/pro-regular-svg-icons/faTags';
import { faThumbtack as farThumbtack } from '@fortawesome/pro-regular-svg-icons/faThumbtack';
import { faTimes as farTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faToggleOff as farToggleOff } from '@fortawesome/pro-regular-svg-icons/faToggleOff';
import { faToggleOn as farToggleOn } from '@fortawesome/pro-regular-svg-icons/faToggleOn';
import { faTruckFast as farTruckFast } from '@fortawesome/pro-regular-svg-icons/faTruckFast';
import { faUserSecret as farUserSecret } from '@fortawesome/pro-regular-svg-icons/faUserSecret';
import { faXmark as farXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
// Solid
import { faArrowUpRightFromSquare as fasArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCircleCheck as fasCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCircleXmark as fasCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCode as fasCode } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faExclamationCircle as fasExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle as fasInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faMinus as fasMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faPlus as fasPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faQuestionCircle as fasQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faThumbtack as fasThumbtack } from '@fortawesome/pro-solid-svg-icons/faThumbtack';
import { faTrash as fasTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserCheck as fasUserCheck } from '@fortawesome/pro-solid-svg-icons/faUserCheck';
// Custom icons from Font Awesome Kit
import {
  faLightBuildingColumnsCircleDollar,
  faLightEnvelopeOpenAt,
  faLightLockRotate,
  faLightStoreMagnifyingGlass,
} from '@awesome.me/kit-4ccd0ddec9/icons/kit/custom';

export function registerFontAwesomeIcons(library: FaIconLibrary) {
  library.addIcons(
    // Custom icons
    faLightBuildingColumnsCircleDollar,
    faLightEnvelopeOpenAt,
    faLightLockRotate,
    faLightStoreMagnifyingGlass,
    // Regular
    faEllipsisV,
    farEllipsis,
    farFilter,
    farLifeRing,
    farInfoCircle,
    farUserSecret,
    farCheckCircle,
    farXmark,
    farBuilding,
    farBox,
    farGlobe,
    farCheck,
    farExclamationCircle,
    farPlusCircle,
    farAngleDown,
    farHandHoldingCircleDollar,
    farCircleNotch,
    farThumbtack,
    farCog,
    farPaperclip,
    farHome,
    farSignOut,
    farCloudDownload,
    farTimes,
    farToggleOn,
    farToggleOff,
    farFilePen,
    farPenToSquare,
    farPen,
    farGripDots,
    farTag,
    farBolt,
    farBoltSlash,
    farCodeFork,
    farTags,
    farBallotCheck,
    farTruckFast,
    farStore,
    farBan,
    farCartShopping,
    farCalendarClock,
    farCalendarCheck,
    farFileInvoice,
    farFileInvoiceDollar,
    farOctagonExclamation,
    farPaperPlane,
    farPaperPlaneTop,
    farPersonSimple,
    farFlag,
    farMoneyBillTransfer,
    farChevronLeft,
    farChevronRight,
    farShoppingBasket,
    farChevronUp,
    farChevronDown,
    // Solid
    fasInfoCircle,
    fasExclamationCircle,
    fasExclamationTriangle,
    fasCheck,
    fasChevronLeft,
    fasChevronRight,
    fasCircleCheck,
    fasCircleNotch,
    fasCircleXmark,
    fasClock,
    fasQuestionCircle,
    fasUserCheck,
    fasThumbtack,
    fasPlus,
    fasMinus,
    fasArrowUpRightFromSquare,
    fasCode,
    fasUser,
    // Duotone
    fadStore,
    fadUser,
    fadGlobeEurope,
    fadInfoCircle,
    fadHome,
    fadShoppingCart,
    fadUniversity,
    fadCreditCard,
    fadHandHoldingBox,
    fadHandHoldingUsd,
    fadPiggyBank,
    fadQuestion,
    fadCogs,
    fadExclamationTriangle,
    fadListCheck,
    fadCartShopping,
    fadChartNetwork,
    // Light
    falPlusCircle,
    falCalendarDay,
    falClipboardCheck,
    falBars,
    falBell,
    falStopwatch,
    falCalenderEdit,
    falTimes,
    falShoppingBasket,
    falCog,
    falPaperclip,
    falPaperclipVertical,
    falHouse,
    falExternalLinkSquare,
    falChevronLeft,
    falChevronRight,
    falMemoCircleInfo,
    falCalendar,
    falCalendarCheck,
    falScaleBalanced,
    falScaleUnbalanced,
    falCalculatorSimple,
    falCalculator,
    falXmark,
    falGear,
    falTableColumns,
    falCheck,
    falCircleCheck,
    falFilePdf,
    falFileChartColumn,
    falFileInvoice,
    falDownload,
    falReceipt,
    falCircleQuestion,
    falFileMagnifyingGlass,
    falEye,
    falEllipsisVertical,
    farEllipsisVertical,
    falEllipsisV,
    falXmark,
    falRobot,
    falTrash,
    falCopy,
    falAngleRight,
    falAngleLeft,
    falEyeSlash,
    falDeleteLeft,
    falArrowRightFromBracket,
    falWandMagicSparkles,
    falListTree,
    falList,
    falLifeRing,
    falPrint,
    falExternalLink,
    falEraser,
    falSearchPlus,
    falLightbulbOn,
    falSyncAlt,
    falPlay,
    falPlayCircle,
    falInfoCircle,
    falCircleNotch,
    falCheckCircle,
    falExclamationCircle,
    falStore,
    falWallet,
    falAngleDown,
    falArrowsSplitUpAndLeft,
    falEdit,
    falLock,
    falLockOpen,
    falHistory,
    falClock,
    falFilter,
    falSigma,
    falUser,
    falMoneyBillWave,
    falMoneyCheckPen,
    falPiggyBank,
    falMoneyBillTransfer,
    falListCheck,
    falGearComplex,
    falArrowsRotate,
    falUserCircle,
    falQuestionCircle,
    falCircleExclamation,
    falChevronDown,
    falChevronUp,
    falBolt,
    falHourglassHalf,
    falChartMixed,
    falScrewdriverWrench,
    falBasketShopping,
    falMagnifyingGlass,
    falArrowTurnDownLeft,
    falCreditCardBlank,
    falSpinnerThird,
    falFileExport,
    falBuilding,
    falBuildingColumns,
    falTrashCan,
    falArrowDown,
    falArrowRight,
    falEllipsis,
    falPlus,
    falMinus,
    falTruckFast,
    falFilePen,
    falCreditCard,
    falGiftCard,
    falMoon,
    falSun,
    falKey,
    falLanguage,
    falDesktop,
    falPlug,
    falEnvelope,
    falMobileAlt,
    falPaperPlane,
    falShoppingCart,
    falUsers,
    falBarcode,
    falTimelineArrow,
    falEnvelopeOpenText,
    falEnvelopeOpen,
    falClockRotateLeft,
    falGrid2,
    falMegaphone,
    fasTrash,
    // Brand
    faShopify,
  );
}
